import React from 'react';

const Success = ({ title, message, buttonText, onReturn }) => {
  return (
    <div className="review-container success-card">
      <div className="review-card text-center">
        <img src="/images/checkGreen.svg" alt="check icon" />
        <h3>{title}</h3>
        <p className="subtext">{message}</p>
        <button className="btn-primary w-100 m-t-32" onClick={onReturn}>
          {buttonText}
        </button>
      </div>
    </div>
  );
};

export default Success;
